import { ApexOptions } from "ng-apexcharts";
import {
  createAxisChartDefaults,
  createBarPlotOptions,
  createDonutChartDefaults,
} from "../../shared/charts/chart-defaults";
import { chartColorsForBookingStatuses } from "../../shared/charts/chart-tokens";

const DEFAULT_BOOKING_STATUSES = [
  "tentative",
  "confirmed",
  "cancelled",
  "maintenance",
];

export function buildBookingsTrendChartOptions(): ApexOptions {
  const defaults = createAxisChartDefaults("line", "100%");
  return {
    ...defaults,
    colors: chartColorsForBookingStatuses(DEFAULT_BOOKING_STATUSES),
    legend: { position: "bottom", horizontalAlign: "left" },
    plotOptions: { bar: createBarPlotOptions() },
    stroke: { curve: "smooth", width: [] },
    tooltip: { ...defaults.tooltip, followCursor: true },
    xaxis: {
      ...defaults.xaxis,
      categories: [],
    },
    yaxis: {
      ...defaults.yaxis,
      forceNiceScale: true,
      min: 0,
    },
  };
}

export function buildBookingStatusChartOptions(): ApexOptions {
  return {
    ...createDonutChartDefaults("100%"),
    colors: chartColorsForBookingStatuses(DEFAULT_BOOKING_STATUSES),
    labels: [],
  };
}
